import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Card from 'components/atoms/Cards/Card/Card';

const StyledInsightCard = styled(Card)`
  display: flex;
  flex-direction: column;
  
  .InsightCard {
    &-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: ${props => props.theme.layout('1sp')};

      padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)} ${props => props.theme.spacing(1.5)} ${props => props.theme.spacing(2)};
    }

    &-title {
      display: flex;
      align-items: flex-start;
      gap: ${props => props.theme.layout('0.75sp')};
      
      > *:last-child {
        flex-grow: 1;
        max-width: unset;
        overflow: hidden;
        font-weight: 500;

        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    
    &-text {
      width: 100%;
      overflow: hidden;
      
      &-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        
        .readMore {
          ${props => props.theme.font2Css('caption')};
          position: absolute;
          bottom: ${props => props.theme.layout(15)};
        }
      }
    }
    
    &-footer {
      display: flex;
      align-items: center;
      padding: 0 ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)};
      gap: ${props => props.theme.layout('1sp')};
      overflow: hidden;

      .InsightCard-date {
        line-height: ${props => props.theme.lineHeight('1f')};
        align-items: center;
        color: ${props => props.theme.property('palette.text.disabled')};
        
        margin-top: ${props => props.theme.layout(0)};
        svg {
          margin-top: ${props => props.theme.layout(-1)};
        }

        &.Typography {
          display: flex;
          gap: ${props => props.theme.layout('0.5sp')};

          > * {
            white-space: nowrap;
          }
        }
      }

      span:has(.InsightCard-location) {
        overflow: hidden;
      }
    }
  }
  
  &:has(.readMore) {
    .InsightCard-footer {
      min-height: ${props => props.theme.layout('3.75sp')};
      padding-right: ${props => props.theme.layout('11.5sp')};
    }
  }

  &.InsightCard-clampText {
    .InsightCard-content {
      overflow: hidden !important;
      .InsightCard-text {
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledInsightCard.propTypes = {
  theme: PropTypes.object
};

export default StyledInsightCard;
